import { useMemo } from "react";
import { Table } from "@tanstack/react-table";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { InnovaAlgoTrade } from "@/client-admin/types.gen";
import { DataTableFacetedFilter } from "../EtpaOrdersTable/data-table-faceted-filter";

const statusOptions = [
  { label: "Pending", value: "PENDING" },
  { label: "Active", value: "ACTIVE" },
  { label: "Traded", value: "TRADED" },
  { label: "Partially Filled", value: "PARTIALLY_FILLED" },
  { label: "Cancelled", value: "CANCELLED" },
  { label: "Passed", value: "PASSED" },
  { label: "Withdrawn", value: "WITHDRAWN" },
  { label: "Not Found", value: "NOT_FOUND" },
];

interface DataTableToolbarProps {
  table: Table<InnovaAlgoTrade>;
  data: InnovaAlgoTrade[];
}

export function DataTableToolbar({ table, data }: DataTableToolbarProps) {
  const isFiltered = table.getState().columnFilters.length > 0;

  const contractOptions = useMemo(() => {
    const contracts = new Set(data.map((row) => `${row.Start}–${row.End}`));
    return Array.from(contracts)
      .sort()
      .map((c) => ({ label: c, value: c }));
  }, [data]);

  return (
    <div className="flex items-center gap-2">
      {table.getColumn("Contract") && (
        <DataTableFacetedFilter column={table.getColumn("Contract")!} title="Contract" options={contractOptions} />
      )}
      {table.getColumn("Status") && (
        <DataTableFacetedFilter column={table.getColumn("Status")!} title="Status" options={statusOptions} />
      )}
      <Input
        placeholder="Filter Slice ID..."
        value={(table.getColumn("SliceId")?.getFilterValue() as string) ?? ""}
        onChange={(event) => table.getColumn("SliceId")?.setFilterValue(event.target.value)}
        className="h-8 w-[140px]"
      />
      <Input
        placeholder="Filter Order ID..."
        value={(table.getColumn("OrderId")?.getFilterValue() as string) ?? ""}
        onChange={(event) => table.getColumn("OrderId")?.setFilterValue(event.target.value)}
        className="h-8 w-[140px]"
      />
      {isFiltered && (
        <Button variant="ghost" onClick={() => table.resetColumnFilters()} className="h-8 px-2 lg:px-3">
          Reset
          <X className="ml-2 h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
